import UiAdapter from 'Engine/base/ui/uiAdapter/BaseUiAdapter';
import EntryPoint from 'Engine/EntryPoint';
import eBaseStateTypes from 'Engine/enums/eBaseStateTypes';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';

export default class UiAdapterExtended extends UiAdapter {
  constructor(...props) {
    super(...props);
  }

  addListeners() {
    super.addListeners();
    GlobalDispatcher.add('gameSettings:quickSpin', this._onChangeQuickSpinSetting, this);
  }

  _onChangeQuickSpinSetting({params}) {
    if(params !== window.OPWrapperService.autoPlay.quickPlay) {
      window.OPWrapperService.autoPlay.quickPlay = params
    }
  }
}
